import isObject from './isObject';
import isElement from './isElement';
import {LIB_NAME} from './constants';

export default function validateMarkArguments(context, interactionId, event, options, type) {
	if (process.env.NODE_ENV === 'development') {
		if (!isObject(context) && !isElement(context))
			console.error(`${LIB_NAME} mark() arguments[0] context must be an object.`); // eslint-disable-line no-console
		if (typeof interactionId !== 'string')
			console.error(`${LIB_NAME} mark() arguments[1] interactionId must be a string.`); // eslint-disable-line no-console
		if (typeof event !== 'string')
			console.error(`${LIB_NAME} mark() arguments[2] event must be a string.`); // eslint-disable-line no-console
		if (!isObject(options))
			console.error(`${LIB_NAME} mark() arguments[3] options must be an object.`); // eslint-disable-line no-console
		if (typeof type !== 'string')
			console.error(`${LIB_NAME} mark() arguments[4] type must be a string.`); // eslint-disable-line no-console
	}
}
